import React from 'react';
// auth
export const Login = React.lazy(() => import('../pages/auth/Login'));
export const Register = React.lazy(() => import('../pages/auth/Register'));
export const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
export const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
export const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'));
export const Logout = React.lazy(() => import('../pages/auth/Logout'));

// dashboards
export const DashBoard1 = React.lazy(() => import('../view/Dashboard/'));

// master
export const Areas = React.lazy(() => import('../view/Areas'));
export const Landmark = React.lazy(() => import('../view/Landmark'));
export const Customer = React.lazy(() => import('../view/Customer'));
export const Product = React.lazy(() => import('../view/Product'));
export const Allotment = React.lazy(() => import('../view/Allotment'));
export const ExpenseCategory = React.lazy(() => import('../view/ExpenseCategory'));
export const Designation = React.lazy(() => import('../view/Designation'));
export const Employee = React.lazy(() => import('../view/Employee'));
export const Branch = React.lazy(() => import('../view/branch'));
export const Sales = React.lazy(() => import('../view/Sales'));
export const Collections = React.lazy(() => import('../view/Collections'));
export const Return = React.lazy(() => import('../view/Return'));
export const Expenses = React.lazy(() => import('../view/Expenses'));
export const Outstanding = React.lazy(() => import('../view/Outstanding'));
export const Settings = React.lazy(() => import('../view/Settings'));
export const Draft = React.lazy(() => import('../view/Draft'));
export const AreawiseReport = React.lazy(() => import('../view/Report/AreawiseReport'));
export const DaywiseReport = React.lazy(() => import('../view/Report/DaywiseReport'));
export const ProductwiseReport = React.lazy(() => import('../view/Report/ProductwiseReport'));
export const UserRights = React.lazy(() => import('../view/UserRights'));
export const Tally = React.lazy(() => import('../view/Tally'));

// extra pages
export const Error404 = React.lazy(() => import('../pages/other/Error404'));
export const Error500 = React.lazy(() => import('../pages/other/Error500'));

// icons
export const FeatherIcons = React.lazy(() => import('../pages/icons/FeatherIcons'));
export const MDIIcons = React.lazy(() => import('../pages/icons/MDIIcons'));
export const Dripicons = React.lazy(() => import('../pages/icons/DripiIcons'));
export const FontAwesomeIcons = React.lazy(() => import('../pages/icons/FontAwesomeIcons'));
export const ThemifyIcons = React.lazy(() => import('../pages/icons/ThemifyIcons'));